module.exports = __webpack_public_path__ + "static/img/MondoConneX_Logo.45cb2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MondoConneX_Logo.png
// module id = 200
// module chunks = 14